<template>
  <Drawer width="850" :title="`${openedBill ? '编辑' : '新增'}票据`" v-model="drawerOpened">
    <div class="drawer-content">
      <Form @submit.native.prevent ref="formItem" :model="formItem" :rules="ruleValidate" label-position="top">
        <div class="form-content">
          <div class="form-left">
            <FormItem label="票据类型" prop="type">
              <RadioGroup v-model="formItem.type">
                <Radio label="bankAccBill">
                  <span>银承</span>
                </Radio>
                <Radio label="commAccBill">
                  <span>商承</span>
                </Radio>
                <Radio label="check">
                  <span>支票</span>
                </Radio>
                <Radio label="yun">
                  <span>云信通</span>
                </Radio>
                <Radio label="jian">
                  <span>建信融通</span>
                </Radio>
                <Radio label="bankAccBillPaper">
                  <span>纸质银承</span>
                </Radio>
                <Radio label="gold">
                  <span>金单</span>
                </Radio>
                <Radio label="sywx">
                  <span>商银微芯</span>
                </Radio>
                <Radio label="ji">
                  <span>集信</span>
                </Radio>
                <Radio label="zhu">
                  <span>筑信</span>
                </Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="客户" prop="paidByCustomer">
              <Select v-model="formItem.paidByCustomer" filterable :disabled="openedBill ? true : false" remote style="width: 366px" :remote-method="searchCustomer" :loading="customerLoading" placeholder="请选择客户">
                <Option v-for="option in customersSimple" :value="option._id" :key="option._id" style="width: 366px">{{ option.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="票据所在公司" prop="company">
              <Select v-model="formItem.company" filterable clearable>
                <Option v-for="option in companyList" :value="option._id" :key="option._id">{{ option.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="金额（元）" prop="amount">
              <InputNumber :min="0" v-model="formItem.amount" style="width: 200px"></InputNumber>
            </FormItem>
            <FormItem label="收款人" prop="receivedBy">
              <Select v-model="formItem.receivedBy" filterable clearable>
                <Option v-for="option in simpleUserList" :value="option._id" :key="option._id">{{ option.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="创建人" prop="createdBy">
              <div>
                {{
                  openedBill
                    ? openedBill.createdBy
                      ? openedBill.createdBy.name
                      : ""
                    : user.name
                }}
              </div>
            </FormItem>
            <FormItem label="备注" prop="remark">
              <Input style="width: 320px" v-model="formItem.remark" type="textarea" placeholder="输入备注..." />
            </FormItem>
          </div>
          <div class="form-right">
            <FormItem label="汇票编号" prop="billNo">
              <Input v-model="formItem.billNo"></Input>
            </FormItem>
            <FormItem label="出票公司" prop="billCompany">
              <Input v-model="formItem.billCompany"></Input>
            </FormItem>
            <FormItem label="出票银行" prop="billBank">
              <Input v-model="formItem.billBank"></Input>
            </FormItem>
            <FormItem label="汇票出票" prop="billIssuedAt">
              <DatePicker type="date" v-model="formItem.billIssuedAt" placeholder="选择汇票出票日期"></DatePicker>
            </FormItem>
            <FormItem label="汇票到期" prop="billEndedAt">
              <DatePicker type="date" v-model="formItem.billEndedAt" placeholder="选择汇票到期日期"></DatePicker>
            </FormItem>
            <FormItem label="汇票状态" prop="billStatus">
              <RadioGroup v-model="formItem.billStatus">
                <Radio label="waiting">
                  <span>未到期</span>
                </Radio>
                <Radio label="receive">
                  <span>到期收款</span>
                </Radio>
                <Radio label="overdue">
                  <span>逾期无法兑现</span>
                </Radio>
                <Radio label="paid">
                  <span>支付给供应商</span>
                </Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="票据标签" prop="tags">
              <CheckboxGroup v-model="formItem.tags">
                <Checkbox label="heimingdan">
                  <span>黑名单</span>
                </Checkbox>
                <Checkbox label="ketiexian">
                  <span>可贴现</span>
                </Checkbox>
                <Checkbox label="6+9">
                  <span>6+9</span>
                </Checkbox>
              </CheckboxGroup>
            </FormItem>
          </div>
        </div>
        <div class="bottom-button">
          <FormItem style="margin-left: 16px;margin-bottom: 0">
            <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
          </FormItem>
        </div>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "AddBillDrawer",
  data() {
    return {
      drawerOpened: false,
      customerLoading: false,
      formItem: {
        paidByCustomer: null,
        company: null,
        amount: null,
        receivedBy: null,
        remark: null,
        billNo: null,
        billCompany: null,
        billBank: null,
        billIssuedAt: null,
        billEndedAt: null,
        billStatus: null,
        tags: [],
        type: null,
      },
      openedBill: null,
      openedType: null,
      ruleValidate: {
        abbr: [
          { required: true, message: "账号简称为必填项", trigger: "submit" },
        ],
        bank: [{ required: true, message: "银行为必填项", trigger: "submit" }],
        paidByCustomer: [
          { required: true, message: "客户为必选项", trigger: "submit" },
        ],
        company: [
          { required: true, message: "公司为必选项", trigger: "submit" },
        ],
        type: [
          {
            required: true,
            message: "汇款类型为必选项",
            trigger: "submit",
          },
        ],
        radio: [
          {
            required: true,
            message: "账号状态为必选项",
            trigger: "submit",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      companyList: (state) => state.company.companyList,
      user: (state) => state.auth.currentUser,
      customersSimple: (state) => state.customer.customersSimple,
      simpleUserList: (state) => state.user.simpleUserList,
    }),
  },
  methods: {
    ...mapActions({
      getCompanyList: "company/getCompanyListAction",
      createBill: "bill/createBillAction",
      updateBill: "bill/updateBillAction",
      getCustomerSimpleList: "customer/getCustomerSimpleListAction",
    }),
    async openDrawer(bill, type) {
      this.getCompanyList({});
      this.$refs["formItem"].resetFields();
      this.openedBill = null;
      this.openedType = type;
      if (bill && type === "edit") {
        this.openedBill = bill; // 如果有打开，则为编辑模式
        this.formItem.abbr = bill.abbr;
        this.formItem.bank = bill.bank;
        this.formItem.company = bill.company._id ?? bill.company;
        await this.getCustomerSimpleList({ name: bill.paidByCustomer.name });
        this.formItem.paidByCustomer =
          bill.paidByCustomer._id ?? bill.paidByCustomer;
        this.formItem.receivedBy = bill.receivedBy._id ?? bill.receivedBy;
        this.formItem.type = bill.type;
        this.formItem.tags = bill.tags;
        this.formItem.billNo = bill.billNo;
        this.formItem.billCompany = bill.billCompany;
        this.formItem.billBank = bill.billBank;
        this.formItem.billEndedAt = bill.billEndedAt;
        this.formItem.billIssuedAt = bill.billIssuedAt;
        this.formItem.billStatus = bill.billStatus;
        this.formItem.remark = bill.remark;
        this.formItem.amount = bill.amount;
        this.formItem.radio = String(bill.active);
      } else {
        this.formItem.radio = "true";
      }
      this.drawerOpened = true;
    },
    async searchCustomer(query) {
      if (query !== "" && !this.openedBill) {
        this.customerLoading = true;
        await this.getCustomerSimpleList({ name: query });
        this.customerLoading = false;
      }
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedBill && this.openedType === "edit") {
              this.formItem.active =
                this.formItem.radio === "false" ? false : true;
              delete this.formItem.radio;
              const bill = await this.updateBill({
                id: this.openedBill._id,
                data: this.formItem,
              });
              this.$emit("updateBill", bill, "update");
            } else {
              const bill = await this.createBill(this.formItem);
              this.$emit("updateBill", bill, "create");
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.form-content
  display flex

.form-left
  margin-right 20px
  padding-left 16px
  width 400px

.bottom-button
  position fixed
  bottom 0px
  width 100%
  height 64px
  background-color #f2f6fa
  display flex
  align-items center
  z-index 1

.drawer-content
  padding-left 0
  height 700px
</style>